<template>
  <div>
    <label
      class="block mb-4"
      :class="[themes_labes[theme]]"
      for="dropzone"
      v-if="label"
    >
      <span v-html="label"> </span>
        <span v-if="isExcel == false  && isImage == false" >
          (pdf)
        </span>
        <span v-if="isExcel == true  && isImage == false">
            <span v-if="isCompany == true"><a href ="/forms/tips/declaration_de_la_liste_des_salaries.xlsx">{{ $t("company.download") }}</a></span>
            <span v-else> (excel)</span>
        </span>
      <span v-if="required" class="obligatoire">*</span>
    </label>
    <vue-dropzone
      class="mh-32 mb-3 bg-grey-lighter text-center flex items-center content-center cursor-pointer border border-dashed border-blue-lightest focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
      :id="id"
      ref="VueDropzone"
      :options="dropzoneOptions"
      :url="url"
      :maxFiles="maxFiles"
      :addRemoveLinks="addRemoveLinks"
      :dictDefaultMessage="dictDefaultMessage"
      v-on:vdropzone-sending="sendingEvent"
      v-on:vdropzone-success="vdropzonesuccess"
      v-on:vdropzone-error="vdropzoneError"
      v-on:vdropzone-removed-file="vdropzoneRemovedFile"
      v-on:vdropzone-processing ="vdropzoneProcessing"
    >
      >
    </vue-dropzone>
  </div>
</template>
<style>
.dropzone.vue-dropzone {
  color: #313232;
  border-color: #a6b1c2;
  border-style: dashed;
  background-color: #eaecf1;
  font-family: "Lato", sans-serif;
  position: relative;
  z-index: 1;
  display: block;
}
.dz-default.dz-message {
  display: block;
  width: 100%;
  color: #a0abbd;
  position: relative;
  font-size: 0.875rem;
  margin: 2rem 0 0 0;
}
.dz-default.dz-message:before {
  content: "\f574";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  -webkit-font-smoothing: antialiased;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  position: absolute;
  top: -32px;
  left: calc(50% - 10px);
  font-size: 1.6rem;
}
/*
.dropzone .dz-preview {
    width: 100%;
}
.vue-dropzone .dz-preview .dz-image img:not([src]) {
    width: 100%;
    height: 200px;
    border: none;
}
.dropzone .dz-preview .dz-image img {
    margin: 0 auto;
    border: none;
}
*/
.vue-dropzone .dz-preview .dz-details {
  color: #a0abbd;
  background-color: transparent;
  text-align: center;
}
.vue-dropzone .dz-preview .dz-download {
  color: #a0abbd;
  margin: 0 20px;
  border: 2px #a0abbd solid;
  left: 0;
  right: 0;
  text-decoration: none !important;

  font-size: 0.7rem;
  font-weight: 400;
  border-radius: 5px;
  background: #f1efef;

  position: absolute;
  z-index: 30;
  padding: 10px;
  top: inherit;
  bottom: 15px;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1.1px;
  opacity: 0;
  cursor: pointer;
}
.vue-dropzone .dz-preview:hover .dz-download {
  opacity: 1;
}
.vue-dropzone .dz-preview .dz-remove {
  color: #a0abbd;
  margin: 0 20px;
  border: 2px #a0abbd solid;
  left: 0;
  right: 0;
  text-decoration: none !important;

  font-size: 0.7rem;
  font-weight: 400;
  border-radius: 5px;
  background: #f1efef;
  bottom:70px;
}
.dropzone .dz-preview .dz-error-message {
  opacity: 1 !important;
}
.dropzone .dz-preview .dz-error-message:after {
  left: calc(50% - 5px);
}

.dropzone .dz-preview.dz-file-preview .dz-image {
  /* border: none; */
  border-radius: 0;
  /* background: transparent; */
}
.dropzone .dz-preview.dz-image-preview {
  background: transparent;
  min-height: 200px;
}

.vue-dropzone .dz-preview .dz-details .dz-size span {
  display: none;
}

</style>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { x_api_key } from "@/common/config";
export default {
  name: "sp-dropzone",
  components: {
    "vue-dropzone": vue2Dropzone
  },
  props: {
    label: String,
    url: String,
    maxFiles: Number,
    addRemoveLinks: {
      required: false,
      type: Boolean,
      default: true
    },
    dictDefaultMessage: String,
    acceptedFiles: {
      required: false,
      type: String,
      tag: String,
      default: "application/pdf",
      maxFiles: 4,
        //"image/*,application/pdf,xlsx,xlsm,xltx,xltm,xls,xlt,xla,xlsx,csv,text/csv,application/vnd.ms-excel,application/vnd.ms-excel,application/msexcel,application/x-msexcel,application/x-excel,application/x-dos_ms_excel,application/xls,application/x-xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    },
    type: {
      required: false,
      type: String,
      default: "0"
    },
    tag: {
      required: false,
      type: String,
      default: "1"
    },
    theme: {
      required: false,
      type: String,
      default: ""
    },
    id: String,
    response: {
      required: false,
      type: Object
    },
    question: {
      required: false,
      type: [Object, Array],
      default: null
    },
    cinFile: {
      required: false,
      type: Object,
      default: null
    },
    passportFile: {
      required: false,
      type: Object,
      default: null
    },
    vdropzonesuccess: {
      required: false,
      type: [Function, String],
      default: "dropzoneSuccess"
    },
    vdropzoneError: {
      required: false,
      type: [Function, String],
      default: "vdropzoneError"
    },
    vdropzoneRemovedFile: {
      required: false,
      type: [Function, String],
      default: "vdropzoneRemovedFile"
    },
    vdropzoneProcessing:{
      required: false,
      type: [Function, String],
      default: "vdropzoneProcessing"
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    isExcel: {
      type: Boolean,
      default: false
    },
    isImage: {
        type: Boolean,
        default: false
    },
    downloadFile:{
        required:false,
        type: Boolean,
        default: false
    },
    isCompany:{
        required:false,
        type: Boolean,
        default: false
    },
    startupInfo:{
        required:false,
        type: Boolean,
        default: false
    }
  },
  data: function() {
    return {
      dropzoneOptions: {
        paramName: "document",
        url: this.url ? this.url : "/",
        chunking: false,
        maxFiles: this.maxFiles ? this.maxFiles : 50,
        uploadMultiple: false,
        parallelUploads: 1,
        maxFilesize: 100000,
        timeout: 18000000,
        //retryChunks: true,
        parallelChunkUploads: false,
        acceptedFiles: this.isExcel ? '.xlsx,.xps,.xml,.xlw,.xltx,.xltm,.xlsm,.xlsb,.xls,.csv' : this.acceptedFiles,
        //chunkSize: 2097152,
        autoProcessQueue: true,
        addRemoveLinks: this.addRemoveLinks,
        dictDefaultMessage: this.dictDefaultMessage
          ? this.dictDefaultMessage
          : "<i class='fa fa-cloud-upload'></i>" + this.$i18n.t('form.dropzoneMessage'),
        headers: {
          Authorization: localStorage.getItem("id_token"),
          "x-api-key": x_api_key
        }
      },
      themes: {
        default: "",
        form:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        team:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
      },
      themes_labes: {
        default: "mb-4",
        form: "text-blue text-2sm mb-4",
        team: "text-blue text-2sm font-bold mb-3"
      }
    };
  },
  methods: {
    sendingEvent(document, xhr, formData) {
      formData.append("type", this.type);
      formData.append("tag", this.tag);
      if (this.startupInfo) {
        formData.append("startup_info", true);
      }
    },
    dropzoneSuccess(file, response) {
      this.model = response.data;
    },
    fileDawnoldHandler(file){
        if(this.downloadFile) {
            var download_doc = document.createElement('a');
            download_doc.setAttribute('href', file.path);
            download_doc.setAttribute('class', 'dz-download');
            download_doc.setAttribute('target', '_blank');
            download_doc.innerHTML = "Télécharger";
            file.previewTemplate.appendChild(download_doc);
        }
    }
  },
  mounted() {
    if (
      this.question != null &&
      typeof this.question.content !== "undefined" &&
      this.question.content != null &&
      this.question.content.length != null &&
      this.question.content.length > 0
    ) {
      Array.prototype.forEach.call(this.question.content, content => {
        if(this.response && content != null) this.response.content.push(content.id);
          if (content != null) {
              let file = {
              size: 123,
              name: content.name,
              type: content.mime_type,
              id: content.id,
              path: content.path
            };
            let url = content.path;
            this.$refs.VueDropzone.manuallyAddFile(file, url);
            // this.$refs.VueDropzone.emit('thumbnail', file, url)
            this.fileDawnoldHandler(file)
          }
      });
    }
    if(this.disabled)  this.$refs.VueDropzone.disable();
  },
  watch: {

    cinFile() {
        this.$refs.VueDropzone.removeAllFiles(true);
        if (this.cinFile != null) {
         this.$refs.VueDropzone.removeAllFiles(true);
         let file = {
          size: 123,
          name: this.cinFile.name,
          type: this.cinFile.mime_type,
          id: this.cinFile.id,
            path: this.cinFile.path
        };
        let url = this.cinFile.path;
        this.$refs.VueDropzone.manuallyAddFile(file, url);
        this.fileDawnoldHandler(file)
      }
    },
    passportFile() {
      this.$refs.VueDropzone.removeAllFiles(true);
        if (this.passportFile != null) {
         this.$refs.VueDropzone.removeAllFiles(true);
         let file = {
          size: 123,
          name: this.passportFile.name,
          type: this.passportFile.mime_type,
          id: this.passportFile.id,
            path: this.passportFile.path
        };
        let url = this.passportFile.path;
        this.$refs.VueDropzone.manuallyAddFile(file, url);
        this.fileDawnoldHandler(file)
      }
    }
  }
};
</script>
